// .js-topics-slider
$(function() {
	$('.js-topics-slider').slick({
		speed: 1000,
		dots: false,
		arrows: true,
	});

	$('.js-products-slider').slick({
		speed: 1000,
		dots: false,
		arrows: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			}
		}]
	});

	if(document.documentMode && navigator.msSaveOrOpenBlob){
		window.addEventListener("click", function(eve){
			var a = eve.target
			if(!a.hasAttribute("download")) return
			eve.preventDefault()
			var filename = a.getAttribute("download")
			var xhr = new XMLHttpRequest()
			xhr.open("GET", a.href)
			xhr.responseType = "blob"
			xhr.send()
			xhr.onload = function(){
				navigator.msSaveOrOpenBlob(xhr.response, filename)
			}
		})
	}
});
